import EnrollmentDataService from 'services/data-handler-services/enrollment-data-service';
import TimeoutService from 'services/browser-handler-services/timeout-service';
import $ from 'jquery';
import _ from 'lodash';
import Chaplin from 'chaplin';

const ScoreService = {
  // Service for scoring game block games
  // Scoring Algo: Base + (Base * Timing Bonus) * (Chain Multiplier)
  defaultSettings: {
    base_value: 1,
    time_bonus_intervals: 5,
    time_bonus_time_array: [],
    time_bonus_time: 1000,
    time_bonus_value: 1,
    chain_multiplier_value: 1,
    chain_multiplier_max: 10,
    cancel_chain_with_time: false,
  },

  scoringSettings: {},

  scoreVars: {
    currentScore: 0,
    currentChainBonus: 0,
    currentTimeBonus: 0,
  },

  time_bonus_timeout: null,

  // initialize the score service settings
  init: function (settings) {
    this.resetFull();
    this.scoringSettings = _.defaults(settings, this.defaultSettings);

    // there is the possibility that time bonuses are not conferred with a static time
    for (let i = 0; i < this.scoringSettings.time_bonus_intervals; i++) {
      if (this.scoringSettings.time_bonus_time_array[i]) {
        this.scoringSettings.time_bonus_time_array.push(this.scoringSettings.time_bonus_time_array[i]);
      } else {
        this.scoringSettings.time_bonus_time_array.push(this.scoringSettings.time_bonus_time);
      }
    }
    this.publishScore('init');
  },

  // kick off a timer
  start: function () {
    this.clearTimer();
    this.resetTimeBonus();
    this.time_bonus_timeout = new TimeoutService(
      this.scoringSettings.time_bonus_time_array[this.scoreVars.currentTimeBonus - 1],
      this.decrementTimeBonus.bind(this)
    );
    this.time_bonus_timeout.play();
    this.publishScore();
  },

  // update the score service based on player answer info (correct/incorrect)
  update: function (params) {
    if (params.correct) {
      const points = this.calcPoints();
      this.scoreVars.currentScore += points;
      this.scoreVars.currentChainBonus =
        this.scoreVars.currentChainBonus + 1 > this.scoringSettings.chain_multiplier_max
          ? this.scoringSettings.chain_multiplier_max
          : this.scoreVars.currentChainBonus + 1;
    } else {
      this.resetChainBonus();
    }
    this.reportScore({
      type: params.type,
      level: params.level,
      score: this.scoreVars.currentScore,
    });
    this.setElementValues();
    this.publishScore('update');
  },

  // pause the score service timer
  pause: function () {
    this.time_bonus_timeout.pause();
  },

  // play/resume the score service timer
  play: function () {
    this.time_bonus_timeout.play();
  },

  // report score data to backend/local storage
  // saving level score to key 'assessment_slug_level_#'
  reportScore: function (params) {
    const id = `${params.type}_level_${params.level}`;
    EnrollmentDataService.saveData(id, params.score);
  },

  // algorithim to determine points for correct answer
  calcPoints: function () {
    const s = this.scoringSettings;
    const v = this.scoreVars;
    return s.base_value + s.time_bonus_value * v.currentTimeBonus * (s.chain_multiplier_value * v.currentChainBonus);
  },

  // decrement the time bonus
  decrementTimeBonus: function () {
    // decrement the time bonus
    this.scoreVars.currentTimeBonus--;
    // if the time bonus is over
    if (this.scoreVars.currentTimeBonus === 0 && this.scoringSettings.cancel_chain_with_time) {
      this.resetChainBonus();
    } else {
      this.time_bonus_timeout.set(
        this.scoringSettings.time_bonus_time_array[this.scoreVars.currentTimeBonus - 1],
        this.decrementTimeBonus.bind(this)
      );
      this.time_bonus_timeout.play();
    }
    this.setElementValues();
  },

  getScore: function () {
    return this.scoreVars;
  },

  publishScore: function (tag) {
    Chaplin.mediator.publish(`score:${tag}`, this.scoreVars);
  },

  // full reset of score service variables and timer
  resetFull: function () {
    this.scoringSettings.time_bonus_time_array = [];
    this.scoreVars.currentScore = 0;
    this.resetTimeBonus();
    this.resetChainBonus();
    this.clearTimer();
    this.publishScore('reset');
  },

  // reset just the time bonus
  resetTimeBonus: function () {
    this.scoreVars.currentTimeBonus = this.scoringSettings.time_bonus_intervals;
    this.publishScore();
  },

  // reset just the chain bonus
  resetChainBonus: function () {
    this.scoreVars.currentChainBonus = 0;
    this.publishScore('chain:reset');
  },

  // clear out the timer
  clearTimer: function () {
    if (this.time_bonus_timeout !== null) {
      this.time_bonus_timeout.clear();
      this.time_bonus_timeout = null;
    }
  },

  // set element values (if they exist)
  setElementValues: function (lvl) {
    $('#score-container .current-level .data').html(lvl);
    $('#score-container .current-score .data').html(this.scoreVars.currentScore);
    $('#score-container .current-chain .data').html(this.scoreVars.currentChainBonus);
    $('#score-container .current-time .data').html(this.scoreVars.currentTimeBonus);
  },

  setSubscribe: function () {
    Chaplin.mediator.subscribe('score:get', () => {
      this.publishScore('get:return');
    });
  },

  clearSubscribe: function () {
    Chaplin.mediator.unsubscribe('score:get');
  },
};

export default ScoreService;
